// @flow

class ValidationResult {
  facilityCode: boolean
  facilityName: boolean

  constructor() {
    this.facilityCode = false
    this.facilityName = false
  }

  isValid(): boolean {
    return Object.entries(this).every(([_, isValid]) => isValid)
  }

  update(fieldName: $Keys<ValidationResult>, isValid: boolean): ValidationResult {
    const clone = Object.assign(Object.create(Object.getPrototypeOf(this)), this)

    clone[(fieldName: string)] = isValid

    // $FlowFixMe[incompatible-return]
    return clone
  }
}

export default ValidationResult
